/**
 * @Description: 用户的收货地址信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  ShoppingAddressModel,
  ShoppingAddressSearchModel,
  ShoppingAddressPageSearchModel,
  ShoppingAddressAddModel,
  ShoppingAddressUpdateModel,
  IdsModel
} from '@/model/product/ShoppingAddressModel'

const baseUrl = Route.product + '/shoppingAddress'

/**
 * 搜索分页数据
 */
export const pageSearchShoppingAddress = (param: ShoppingAddressPageSearchModel) => {
  return https().request<RootObject<PageRespModel<ShoppingAddressModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchShoppingAddress = (param: ShoppingAddressSearchModel) => {
  return https().request<RootObject<ShoppingAddressModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getShoppingAddress = (id: number) => {
  return https().request<RootObject<ShoppingAddressModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addShoppingAddress = (param: ShoppingAddressAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateShoppingAddress = (param: ShoppingAddressUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeShoppingAddress = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveShoppingAddress = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
